import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
const EditForm = ({ user, onClose, onEdit }) => {
  const [formData, setFormData] = useState({
    id: null,
    name: "",
    email: "",
    schoolName: "",
    schoolCode: "",
    designation: "Principal",
    website: "",
    phone: "",
    city: "",
    state:"",
    pincode:""
  });

  useEffect(() => {
    if (user) {
      setFormData({
        id: user.id || null,
        name: user.name || "",
        email: user.email || "",
        schoolName: user.schoolName || "",
        schoolCode: user.schoolCode || "",
        designation: user.designation || "Principal",
        website: user.website || "",
        phone: user.phone || "",
        city: user.city || "",
        state:  user.state || "",
        pincode: user.pincode || ""
      });
    }
  }, [user]);

  const handleSubmit = () => {
    if (!formData.name || !formData.schoolName) {
      alert("Name and School Name are required");
      return;
    }

    if (formData.phone && formData.phone.length !== 10) {
      alert("Phone must be 10 digits");
      return;
    }

    if (onEdit) {
      onEdit(formData);
    }
  };
const handleChange = async (e) => {
  const { name, value } = e.target;

  if (name === "phone" && (!/^\d*$/.test(value) || value.length > 10)) return;
  if (name === "pincode" && (!/^\d*$/.test(value) || value.length > 6)) return;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
    ...(name === "schoolName"
      ? { schoolCode: generateSchoolCode(value) }
      : {}),
  }));

  if (name === "pincode" && value.length < 6) {
    setFormData((prev) => ({
      ...prev,
      city: "",
      state: "",
    }));
    return;
  }

  if (name === "pincode" && value.length === 6) {
    try {
      const res = await fetch(`https://api.postalpincode.in/pincode/${value}`);
      const data = await res.json();

      if (data[0].Status === "Success") {
        const postOffice = data[0].PostOffice[0];

        setFormData((prev) => ({
          ...prev,
          city: postOffice.District,
          state: postOffice.State,
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          city: "",
          state: "",
        }));
        toast.error("Invalid Pincode");
      }
    } catch (error) {
      console.error("Pincode fetch error:", error);
      toast.error("Failed to fetch location");
    }
  }
};




const generateSchoolCode = (schoolName) => {
  const words = schoolName
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (words.length === 0) return "";

  // Take first letter of each word
  const letters = words
    .map(word => word.charAt(0).toUpperCase())
    .join("")
    .slice(0, 4); // Maximum 4 letters

  const randomDigits = (length) => {
    let digits = "";
    for (let i = 0; i < length; i++) {
      digits += Math.floor(Math.random() * 10);
    }
    return digits;
  };

  if (letters.length >= 4) {
    return letters; // Already 4 characters
  }

  return letters + randomDigits(4 - letters.length);
};

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-lg p-6">
        
        <div className="flex justify-between items-center border-b pb-3 mb-4">
          <h2 className="text-xl font-semibold text-gray-800">Fill New Form</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-800 text-lg">
            ✕
          </button>
        </div>

        <div className="space-y-4 max-h-[70vh] overflow-y-auto">
          
            <div>
              <label className="block font-semibold text-gray-700">Contact Person Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter full name"
                className="w-full border rounded-md px-3 py-2 mt-1"
              />
            </div>
            <div>
                <label className="labelStyle">Designation</label>
                <select
                  name="designation"
                  value={formData.designation}
                  onChange={handleChange}
                  className="w-full border rounded-md px-3 py-2 mt-1"
                  defaultValue="Principal"
                >
                  <option value="" disabled>Select designation</option>
                  <option value="Principal">Principal</option>
                  <option value="Vice Principal">Vice Principal</option>
                  <option value="Technical Staff">Technical Staff</option>
                  <option value="School Staff">School Staff</option>
                </select>
            </div>

            <div>
              <label className="block font-semibold text-gray-700">School Name</label>
              <input
                type="text"
                name="schoolName"
                value={formData.schoolName}
                onChange={handleChange}
                placeholder="Enter School name"
                className="w-full border rounded-md px-3 py-2 mt-1"
                required
              />
            </div>
            <div>
              <label className="block font-semibold text-gray-700">School Code *</label>
              <input
                type="text"
                name="schoolCode"
                value={formData.schoolCode}
                onChange={handleChange}
                placeholder="Enter School Code"
                className="w-full border rounded-md px-3 py-2 mt-1"
                readOnly
              />
            </div>
            <div>
                <label className="labelStyle">School Website(url)</label>
                <input
                  name="website"
                  value={formData.website}
                  placeholder="Enter school website (url)"
                  onChange={handleChange}
                  className="w-full border rounded-md px-3 py-2 mt-1"
                />
            </div>
          
          <div>
            <label className="block font-semibold text-gray-700">Email (This email will be used for further communication) *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email"
              className="w-full border rounded-md px-3 py-2 mt-1"
            />
          </div>

          <div>
            <label className="block font-semibold text-gray-700">Pincode</label>
            <input
              type="text"
              name="pincode"
              value={formData.pincode}
              onChange={handleChange}
              placeholder="Enter pincode"
              className="w-full border rounded-md px-3 py-2 mt-1"
            />
          </div>
          
            <div>
              <label className="block font-semibold text-gray-700">City</label>
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="Enter city"
                className="w-full border rounded-md px-3 py-2 mt-1"
                readOnly
              />
            </div>

            <div>
              <label className="block font-semibold text-gray-700">State</label>
              <input
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
                placeholder="Enter state"
                className="w-full border rounded-md px-3 py-2 mt-1"
                readOnly
              />
            </div>
          
          

          

          <div>
            <label className="block font-semibold text-gray-700">Phone No.</label>
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Enter 10 digit phone"
              maxLength={10}
              className="w-full border rounded-md px-3 py-2 mt-1"
            />
          </div>
        

        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditForm;